module.exports = __webpack_public_path__ + "aacbc44fcb5989b403a2d6788c8d81ca.jpg";